<template>
    <div>
        <HeaderSection icon="fas fa-user-plus" title="Editar usuario">
            <template slot="buttons">
                <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion/usuarios')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <el-form ref="user-form" :model="userForm">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                            label="Usuario"
                            prop="username"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                        <el-input v-model="userForm.username" disabled>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Representación" prop="office"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-select
                                filterable
                                v-model="userForm.office"
                                style="width:100%"
                                placeholder="Seleccionar">
                            <el-option
                                    v-for="office in offices"
                                    :key="office.id"
                                    :label="office.representation_name"
                                    :value="office.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Perfil" prop="profile" 
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-select
                                @change="isAbleForRegions"
                                filterable
                                v-model="userForm.profile"
                                style="width:100%"
                                placeholder="Seleccionar">
                            <el-option
                                    v-for="profile in profiles"
                                    :key="profile.id"
                                    :label="profile.name"
                                    :value="profile.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8" v-if="[1, 4, 5, 6, 7, 8, 9, 10, 11].includes(userForm.profile)">
                    <el-form-item label="Región" prop="regions" :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change'}">
                                <el-select
                                        filterable clearable multiple
                                        v-model="userForm.regions"
                                        style="width:100%"
                                        placeholder="Seleccionar">
                                    <el-option
                                            v-for="region in regions"
                                            :key="region.id"
                                            :label="region.name"
                                            :value="region.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                </el-col>
            </el-row>
            <el-row :gutter="20" v-if="userForm.profile == 2">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-checkbox @change="changeInformatic(isInformatic)" v-model="isInformatic"
                                     style="padding: 10px">
                            Asignar como Informático Responsable
                        </el-checkbox>
                    </el-col>
                </el-row>

                <el-card shadow="never" v-if="isInformatic">
                    <div slot="header">
                        <span>Informático Responsable (I.R.)</span>
                    </div>
                    <div class="tip">
                        <span>Seleccione las Representaciones en las que el usuario será I.R.</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="Representación" prop="offices">
                                <el-select
                                        filterable clearable multiple
                                        v-model="officesIds"
                                        style="width:100%"
                                        placeholder="Seleccionar">
                                    <el-option
                                            v-for="office in offices"
                                            :key="office.id"
                                            :label="office.representation_name"
                                            :value="office.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="Nombre (s)"
                                  prop="name"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-input placeholder="Nombre" v-model="userForm.name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Primer apellido"
                                  prop="firstName"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-input placeholder="Nombre" v-model="userForm.firstName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Segundo apellido"
                                  prop="secondName"
                                  :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-input placeholder="Nombre" v-model="userForm.secondName"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="Puesto"
                                  prop="job"
                                  :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-input v-model="userForm.job"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="" prop="offices">
                        <el-checkbox v-model="userForm.isAuthorizer" style="padding: 10px">
                            Asignar como responsable para dar Visto Bueno
                        </el-checkbox>
                    </el-form-item>

                </el-col>
            </el-row>
            <br>
            <el-row class="custom-header" type="flex" justify="space-between">
                <el-col>
                    <h3 class="custom-title">
                        <i class="fas fa-signature"></i>
                        Asignar como:
                    </h3>
                </el-col>
            </el-row>
            <el-row>
                <el-col>
                    <el-checkbox-group v-model="checkList" :max="1" @change="validateUsers">
                        <el-checkbox :label="1">Elaboró</el-checkbox>
                        <el-checkbox :label="2">Revisó</el-checkbox>
                        <el-checkbox :label="3">Autorizó</el-checkbox>
                    </el-checkbox-group>
                </el-col>
            </el-row>
            <br>
            <el-row :gutter="20">
                <el-col :span="24" align="end">
                    <el-button
                            size="medium"
                            type="danger"
                            icon="el-icon-arrow-left"
                            @click="$router.push('/administracion/usuarios')">
                        Cancelar
                    </el-button>
                    <el-button
                            type="primary"
                            size="medium"
                            icon="far fa-save"
                            @click="submitForm('user-form')">
                        Guardar
                    </el-button>
                </el-col>
            </el-row>

        </el-form>


    </div>
</template>

<script>
    import {mapState, mapGetters, mapMutations} from 'vuex';
    import HeaderSection from '../../../partials/HeaderSection';
    // import VuePassword from 'vue-password';

    export default {
        components: {
            HeaderSection,
            // VuePassword,
        },

        data() {
            return {
                isUserValid: false,
                isInformatic: false,
                officesIds: [],
                regions: [],
                offices: [],
                profiles: [],
                userForm: {
                    id: '',
                    username: '',
                    name: '',
                    firstName: '',
                    secondName: '',
                    email: '',
                    office: '',
                    profile: '',
                    job: '',
                    offices: [],
                    regions: [],
                    isAuthorizer: false,
                },
                checkList: []
            };
        },

        computed: {
            ...mapState([
                'route'
            ]),

        },


        created() {

            this.$store.dispatch(
                'loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});
            axios.get(`/api/users/${this.$route.params.id}/edit`).then(response => {

                let data = response.data;
                this.regions = data.regions;
                this.profiles = data.profiles;
                this.offices = data.offices;
                this.userForm = data.form;
                this.userForm.isAuthorizer == 1 ? this.userForm.isAuthorizer = true : this.userForm.isAuthorizer = false;

                if (data.informatics && data.informatics.length > 0) {

                    this.isInformatic = true;
                    this.officesIds = data.informatics

                }
                console.log('userForm ', this.userForm)
                if (data.user.signing_ids && data.user.signing_ids.length > 0) {
                    this.checkList = data.user.signing_ids;
                    console.log('list ', this.checkList)
                }

                this.$store.dispatch('loading/spinner', {}, {root: true});

            }).catch(error => {
                this.$notify.error({
                    title: 'Error',
                    message: 'Ocurrió un error inesperado al mostrar los datos de usuario'
                });

            });
        },

        methods: {

            validateUsers() {

               /* if(this.checkList.length > 0){
                    let _data = {
                        ...this.userForm,
                        cat_signing_id: this.checkList
                    }
                    axios.post('/api/sign-users', _data).then( response => {
                        if(response.data.success){
                            this.$notify({
                                title: 'Éxito',
                                message: response.data.message,
                                type: 'success'
                            });
                            this.checkList = [];
                        }else{
                            this.$notify({
                                title: 'Atención',
                                message: response.data.message,
                                type: 'warning'
                            });
                        }
                    }).catch(e => {
                        console.log('error validateUsers ', e);
                        this.$notify({
                            title: 'Error',
                            message: 'No se pudo procesar su solicitud.',
                            type: 'error'
                        });
                    })
                }*/

            },

            isAbleForRegions(profile) {
                if ( ![1, 4, 5, 6, 7, 8, 9, 10, 11].includes(profile) ) {
                    this.userForm.regions = []
                }
            },

            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.$store.dispatch(
                            'loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});

                        let data =
                            {
                                id: this.userForm.id,
                                username: this.userForm.username,
                                name: this.userForm.name,
                                firstName: this.userForm.firstName,
                                secondName: this.userForm.secondName,
                                profile: this.userForm.profile,
                                office: this.userForm.office,
                                regions: this.userForm.regions,
                                job: this.userForm.job,
                                offices: this.officesIds,
                                isAuthorizer: this.userForm.isAuthorizer,
                                checkList: this.checkList
                            };
                        axios.put(`/api/users/${this.$route.params.id}`, data).then(response => {

                            this.$store.dispatch('loading/spinner', {}, {root: true});
                            if (response.data.success) {
                                this.$notify({
                                    title: 'Éxito',
                                    message: 'Actualización correcta',
                                    type: 'success'
                                });

                                this.$router.push('/administracion/usuarios');
                            } else {
                                this.$store.dispatch('loading/spinner', {}, {root: true});
                                this.$notify({
                                    title: 'Error',
                                    message: 'No fue posible actualizar la infromación del usuario, trate nuevamente',
                                    type: 'error'
                                });
                            }

                        }).catch(error => {
                            this.$store.dispatch('loading/spinner', {}, {root: true});
                            this.$notify({
                                title: 'Error',
                                message: 'Se interrumpió la conexión con el servidor',
                                type: 'error'
                            });
                        });

                    } else {
                        this.$notify({
                            title: 'Mensaje',
                            message: 'Por favor complete todos los campos requeridos.',
                            type: 'warning'
                        });
                        return false;
                    }
                });

            },

            changeInformatic(item) {
                if (item == false) {
                    this.officesIds = []
                }
            }

        }
    }
</script>

<style>
    .custom-header {
        border-bottom: 1px solid #eaeefb;
        margin-bottom: 1em;
        padding-bottom: 0.5em;
    }

    .custom-title {
        margin: 0;
        padding-top: 0.25em;
    }
</style>
